//
//
//
//
//
//
//
//

import {
  CRM_PIPELINE_GAMEDESIGN,
  CRM_STATUS_GAMEDESIGN,
  CRM_TAGS_GAMEDESIGN,
} from '../../../const/amo'
import AllSections from '~/components/redesign/AllSections'

export default {
  name: 'CodingGamedesignPage',
  components: {
    AllSections,
  },
  data() {
    return {
      crmPipeline: CRM_PIPELINE_GAMEDESIGN,
      crmStatus: CRM_STATUS_GAMEDESIGN,
      crmTags: CRM_TAGS_GAMEDESIGN,
    }
  },
}
